import { Dispatch, SetStateAction } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { getRockerboxApplicantsRoute } from '../api/constant';
import { rockerEmployerList, rockerboxApplicantKey, rockerboxEmployerKey } from '../constants';

type useGetRockerboxApplicantssProps = {
    searchValue: string;
    status: string;
    sortedDirection: string;
    enabled: boolean | string | null;
    page: number;
    columnNo: number;
    companyId: number;
    page_length: number;
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useGetRockerboxApplicants = ({
    page,
    page_length,
    status,
    enabled,
    columnNo,
    companyId,
    sortedDirection,
    searchValue,
    setAlertText = () => { },
}: useGetRockerboxApplicantssProps) => {
    const client = useQueryClient();

    const queryString = `?page=${page}&page_length=${page_length}&company_id=${companyId}&query=${searchValue}&sort_columns=${columnNo}&sort_direction=${sortedDirection}&wotc_enabled=${enabled}`;
    const { data: rockerboxList, isFetching: isLoadingrockerboxList } =

        useQuery({
            queryKey: [rockerboxApplicantKey, status, companyId, columnNo, sortedDirection, , page, searchValue, page_length, enabled],
            queryFn: () =>

                axiosInstance
                    .get(getRockerboxApplicantsRoute + queryString)
                    .then((res) => res.data),
            // enabled: !!companyId,
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setAlertText(data.message);
                } else {
                    setAlertText('');
                }
            },
            onError: () => {
                setAlertText(errorMessage);
            },
            refetchOnWindowFocus: false,
        });

    return {
        rockerboxList,
        isLoadingrockerboxList,
    };
};
